export function hasActiveFilters(routeQuery) {
  const filters = JSON.parse(routeQuery?.filters || "{}");
  return Object.keys(filters).length > 0;
}

// Filtros para una exportación: los del listado más, si hay registros
// tildados, un IN por clave primaria (mismo formato que "Comparar").
export function filtrosConSeleccion(filtersJSON, primaryKey, idsSeleccionados) {
  if (!idsSeleccionados.length) {
    return filtersJSON;
  }
  return JSON.stringify({
    ...JSON.parse(filtersJSON || "{}"),
    [primaryKey]: { type: "IN", value: idsSeleccionados },
  });
}

// Ids marcados en el selectedRecordsList de CardList: "seleccionar todos" y
// destildar deja las claves en false, que no cuentan como selección.
export function idsTildados(selectedRecordsList) {
  return Object.keys(selectedRecordsList).filter((id) => selectedRecordsList[id]);
}
